// Teams call link in a chat bubble (utils/teams/teamsCall.teamsCallOf): the message the call
// buttons of a Teams chat send, or any message with a Teams meeting link. "Join now" opens the
// link; Teams then offers its app or the browser. The row stays a normal text message.
// Divs only inside bubbles: the bubble CSS forces its own font onto spans.
import React, { useContext } from "react";
import MaterialIcon from "../MaterialIcon";
import LanguageContext from "../../helper/LanguageContext";
import "./TeamsCallMessage.css";

// Always a new tab, Kjuup stays open. Not "noopener" in the features: then window.open returns
// null even when the tab opened, and the fallback took Kjuup's own tab to Teams.
export function openTeamsMeeting(url) {
  if (!url) return;
  const win = window.open(url, "_blank");
  if (!win) return;
  try {
    win.opener = null;
  } catch (_) {
    /* cross-origin already */
  }
}

export default function TeamsCallMessage({ call, body }) {
  const { strings = {}, isGerm } = useContext(LanguageContext) || {};
  const t = (key, en, de) => strings[key] || (isGerm ? de : en);
  if (!call || !call.url) return null;

  const video = call.kind === "video";
  const title =
    call.kind === "video"
      ? t("teams_call_video_title", "Teams video call", "Teams-Videoanruf")
      : call.kind === "audio"
        ? t("teams_call_audio_title", "Teams call", "Teams-Anruf")
        : t("teams_call_meeting_title", "Teams meeting", "Teams-Besprechung");

  return (
    <div className="kjc-tcall">
      <div className="kjc-tcall__head">
        <div className="kjc-tcall__icon">
          <MaterialIcon icon={video ? "videocam" : call.kind === "audio" ? "call" : "groups"} size={18} fill={1} />
        </div>
        <div className="kjc-tcall__kind">{title}</div>
      </div>
      {body ? <div className="kjc-tcall__body">{body}</div> : null}
      <div className="kjc-tcall__foot">
        <button type="button" className="kj-btn kj-btn--primary kjc-tcall__join" onClick={() => openTeamsMeeting(call.url)}>
          <MaterialIcon icon={video ? "videocam" : "call"} size={18} />
          <div>{t("teams_call_join", "Join now", "Jetzt beitreten")}</div>
        </button>
        <div className="kjc-tcall__hint">{t("teams_call_join_hint", "Teams app or browser", "Teams-App oder Browser")}</div>
      </div>
    </div>
  );
}
